import axios from '../../api/instance';

const namespace = 'experiences/';

const SET_EXPERIENCES = namespace + 'set_experiences';
const ADD_EXPERIENCES = namespace + 'add_experiences';

export const FETCH_EXPERIENCES = namespace + 'fetch_experiences';
export const SUBMIT_EXPERIENCE = namespace + 'submit';

export const GET_EXPERIENCES = namespace + 'get_experiences';
export const GET_EXPERIENCES_COUNT = namespace + 'get_experiences_count';

export default {
    state: {
        experiences: [
            {
                id : 14,
                author_id : 343,
                author_name : 'Philippe Thirons',
                rating : 3,
                title : 'Titel',
                text : 'Review',
                status : 'pending',
                language : 1,
                created : '2021-03-17 11:51:00',
                created_by : 343,
                modified : '2021-03-17 11:51:00',
                modified_by : 343
            }
        ]
    },
    mutations: {
        [SET_EXPERIENCES]: (state, experiences) => state.experiences = experiences,
        [ADD_EXPERIENCES]: (state, experience) => state.experiences.splice(0, 0, experience),
    },
    actions: {
        async [FETCH_EXPERIENCES] ({commit})  {
            let experiences = await axios.get('experiences/api/experiences');
            commit(SET_EXPERIENCES, experiences);
        },
        async [SUBMIT_EXPERIENCE] ({commit}, payload) {
            let experiences = await axios.post('experiences/api/experiences', payload);
            commit(SET_EXPERIENCES, experiences);
        },
    },
    getters: {
        [GET_EXPERIENCES]: (state) => state.experiences,
        [GET_EXPERIENCES_COUNT]: (state) => state.experiences.length,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/experiences.js